import { createTheme } from '@mui/material/styles';

// Extend the theme interface to include custom colors
declare module '@mui/material/styles' {
    interface Palette {
        formType: {
            api: string;
            notice: string;
        };
        consentStatus: {
            active: string;
            withdrawn: string;
            laterGranted: string;
            denied: string;
        };
    }

    interface PaletteOptions {
        formType?: {
            api?: string;
            notice?: string;
        };
        consentStatus?: {
            active?: string;
            withdrawn?: string;
            laterGranted?: string;
            denied?: string;
        };
    }
}

export const baseTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
        },
        // Custom colors for forms - use CSS variables for client branding
        formType: {
            api: 'var(--primary-blue, #1976d2)',      // Blue for API forms
            notice: 'var(--primary-green, #388e3c)',   // Green for NOTICE forms
        },
        consentStatus: {
            active: 'var(--success-color, #388e3c)',      // Green for active consent
            withdrawn: 'var(--warning-color, #f57c00)',   // Orange for withdrawn consent
            laterGranted: 'var(--info-color, #1976d2)', // Blue for later granted consent
            denied: 'var(--error-color, #d32f2f)',      // Red for denied consent
        },
    },
    typography: {
        fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});
